// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b2607041","498":"ad4974fd","513":"4510f43e","787":"50d1cbae"}[chunkId] + ".chunk.js";
};